import * as React from 'react';

import i18n from 'helper/i18n';

import { MEASUREMENT_DIAGRAM_PERIOD, MeasurementDiagramPeriodType } from 'store/dashboard/dashboard';

import { HealthGoalTypes, HealthGoalTypesType } from 'components/molecules/HealthGoalSelection';
import { DiagramsType } from 'helper/converter/measurement-diagrams-converter/measurement-diagrams-converter';

import BoardFallback from 'components/molecules/Board/BoardFallback';
import Chart, { ChartColumn } from 'components/molecules/Chart';
import Filter from 'components/molecules/Filter/';
import Slider, { Slide } from 'components/molecules/Slider';

// M1, //last 6 months
// M2 //last 12 month

const tabs = [
	{
		link: '/a',
		id: MEASUREMENT_DIAGRAM_PERIOD.A,
		label: i18n('react.impulsCoach.molecules.BoardTrendSlider.a'),
	},
	{
		link: '/m1',
		id: MEASUREMENT_DIAGRAM_PERIOD.M1,
		label: i18n('react.impulsCoach.molecules.BoardTrendSlider.m1'),
	},
	{
		link: '/m2',
		id: MEASUREMENT_DIAGRAM_PERIOD.M2,
		label: i18n('react.impulsCoach.molecules.BoardTrendSlider.m2'),
	},
];

export type BoardTrendSliderPropsType = {
	isLoading: boolean;
	updateKey: string;
	diagrams?: DiagramsType;
	healthGoal: HealthGoalTypesType;
};

export class BoardTrendSlider extends React.Component<BoardTrendSliderPropsType> {
	public static displayName = 'BoardTrendSlider';

	public shouldComponentUpdate({ updateKey, healthGoal }: BoardTrendSliderPropsType) {
		return updateKey !== this.props.updateKey || healthGoal !== this.props.healthGoal;
	}

	get diagrams(): DiagramsType {
		return this.props.diagrams || {};
	}

	get hasPeriodAColumns(): boolean {
		if (!this.diagrams.A) {
			return false;
		}
		return (this.diagrams.A.columns || []).length > 0;
	}

	get hasPeriodM1Columns(): boolean {
		if (!this.diagrams.M1) {
			return false;
		}
		return (this.diagrams.M1.columns || []).length > 0;
	}

	get hasPeriodM2Columns(): boolean {
		if (!this.diagrams.M2) {
			return false;
		}
		return (this.diagrams.M2.columns || []).length > 0;
	}

	get lineLabel(): string {
		return this.props.healthGoal === HealthGoalTypes.loseWeight
			? i18n('react.impulsCoach.molecules.BoardTrend.target.label')
			: '';
	}

	public renderSlide(name: MeasurementDiagramPeriodType) {
		if ((this.hasPeriodAColumns || this.hasPeriodM1Columns || this.hasPeriodM2Columns) && this.diagrams[name]) {
			return (
				<Chart
					columns={(undefined as any) as ChartColumn[]}
					{...((this.diagrams[name] as any) as any)}
					isLoading={this.props.isLoading}
					modifier={name === MEASUREMENT_DIAGRAM_PERIOD.M2 ? 'year' : undefined}
					line={this.lineLabel}
					tooltips
				/>
			);
		}

		return <BoardFallback />;
	}

	public render() {
		const { isLoading } = this.props;

		if (!isLoading && !this.hasPeriodAColumns && !this.hasPeriodM1Columns && !this.hasPeriodM2Columns) {
			return (
				<div className="m-board-trend__slider">
					<BoardFallback allPeriods />
				</div>
			);
		}

		return (
			<div className="m-board-trend__slider">
				<Slider
					modifier="nav"
					decorator="Nav"
					navChildren={
						<Filter
							isLoading={isLoading}
							isUiControlled
							modifier="nav"
							classNameLink={isLoading ? '' : 'js-m-slider__nav-link'}
							filters={tabs}
							selected={tabs[0].id}
						/>
					}
				>
					{tabs.map((tab) => (
						<Slide key={tab.id}>{this.renderSlide(tab.id as any)}</Slide>
					))}
				</Slider>
			</div>
		);
	}
}

export default BoardTrendSlider;
